import req from "../http";

const logout = {
  // 登出
  logout(params) {
    return req("post", "/auth/logout", params);
  },
};

export default logout;
